module.exports = __webpack_public_path__ + "project-variable.6ba0e6827a1ebf57602d92ad1259f275.hashedasset.svg";